import { getSlot } from 'layout/utils-show-hide.js';
import { ILayoutConfig } from 'redux-state/layout/types.layout.js';
import { ISlotConfig } from 'redux-state/layout/types.modules.js';
import { IPageConfig } from 'redux-state/layout/types.page.js';
import { IMapV2 } from 'types/location.js';

export type modulesToLoadProps = {
  page: ISlotConfig[];
  map?: IMapV2;
};

/**
 * Gets page json
 * Parses any urls and fetches the data (ads, primary, mcp)
 * Merges back
 */
export const normaliseJsonModules = async (pageJson: IPageConfig<'Raw'>): Promise<IPageConfig<'Default'>> => {
  const formatLoadedJson = jsonNormalise(pageJson);
  return { ...pageJson, ...formatLoadedJson };
};

/** Builds data structure and loads modules */
export const jsonNormalise = (
  config: IPageConfig<'Raw'>,
): { layout: ILayoutConfig; modulesToLoad: modulesToLoadProps } => {
  const {
    name,
    title,
    subtitle,
    type,
    primary,
    secondary,
    last,
    navigation,
    search,
    hideWarningsBar,
    maintenance,
    mobileView,
  } = config.layout || {}; // Just in case response does not contain a layout

  const modules = {
    primary: {
      slots: {
        first: getSlot(primary?.slots.first),
        leftMajor: getSlot(primary?.slots['left-major']),
        leftMinor: getSlot(primary?.slots['left-minor']),
        main: getSlot(primary?.slots.main),
        rightMajor: getSlot(primary?.slots['right-major']),
        rightMinor: getSlot(primary?.slots['right-minor'] || primary?.slots.right),
      },
    },
    secondary: {
      slots: {
        major: getSlot(secondary?.slots.major || secondary?.slots.main),
        minor: getSlot(secondary?.slots.minor || secondary?.slots.bottom),
        right: getSlot(secondary?.slots.right),
      },
    },
    last: getSlot(last),
  };

  const layout: ILayoutConfig = {
    ...modules,
    hideWarningsBar,
    maintenance,
    name,
    navigation,
    mobileView,
    search,
    subtitle,
    title,
    type,
    map: primary?.map
      ? {
          ...primary.map,
          ...{
            checkBoxFilterLabel: primary.map?.filterLabel,
            checkboxFilters: primary.map?.filters,
            checkBoxFilterType: primary.map?.filterType,
          },
        }
      : undefined,
  };

  const modulesToLoad = {
    page: [
      layout.primary.slots.first,
      layout.primary.slots.main,
      layout.primary.slots.leftMajor,
      layout.primary.slots.leftMinor,
      layout.primary.slots.rightMajor,
      layout.primary.slots.rightMinor,
      layout.secondary.slots.major,
      layout.secondary.slots.minor,
      layout.secondary.slots.right,
      layout.last,
    ],
    map: layout.map,
  };

  return { layout, modulesToLoad };
};
